"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Save;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _draftJs = require("draft-js");

var _constants = require("composer-plugins/lib/constants");

var _constants2 = require("composer-lib/lib/constants");

var _convertImageEntitiesToBlockData = _interopRequireDefault(require("composer-lib/lib/convertImageEntitiesToBlockData"));

var _immutable = require("immutable");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _setSelectionAfterInsertedEntity = _interopRequireDefault(require("composer-plugins/utils/setSelectionAfterInsertedEntity"));

var HIGHLIGHT_EDITOR_CHANGE_TYPE = 'apply-highlight';

var highlightConversationInComposer = function highlightConversationInComposer(highlightData, content) {
  if (!highlightData) {
    return content;
  }

  var blockKey = highlightData.blockKey,
      highlightText = highlightData.highlightText;

  if (!content.getCurrentContent().getBlockForKey(blockKey)) {
    return content;
  }

  var blockText = content.getCurrentContent().getBlockForKey(blockKey).getText();
  var highlightStart = blockText.indexOf(highlightText);
  var highlightEnd = highlightText.length + highlightStart;

  if (highlightStart < 0) {
    return content;
  }

  var selectionState = _draftJs.SelectionState.createEmpty(blockKey).merge({
    anchorOffset: highlightStart,
    focusOffset: highlightEnd
  });

  var contentStateWithEntity = content.getCurrentContent().createEntity(_constants.HIGHLIGHT_ENTITY_TYPE, 'IMMUTABLE', {});

  var contentState = _draftJs.Modifier.applyEntity(contentStateWithEntity, selectionState, contentStateWithEntity.getLastCreatedEntityKey()); // Technically, not giving an EditorChangeType from the enum is bad...but
  // we can guarantee no one will be editing a readOnly Editor, so this arbitrary string
  // is how we can tell that the last thing we did was highlight text in the editor
  // (important since it is an entity application, it would be difficult to differentiate
  // it from a real edit like, say, insertion of a link, which is also of type `apply-entity`)


  return _draftJs.EditorState.push(content, contentState, HIGHLIGHT_EDITOR_CHANGE_TYPE);
};

function createImageEntityOptions(src, name, attribution) {
  var data = {
    attribution: attribution,
    src: src,
    name: name
  };
  return ['IMAGE', 'IMMUTABLE', data];
}

function createVideoEntityOptions(videoData) {
  return ['VIDEO', 'IMMUTABLE', Object.assign({}, videoData)];
}

function createClipEntityOptions(data) {
  return [_constants.ENTITY_TYPES.clip, 'IMMUTABLE', data];
}

function createLinkEntityOptions(url) {
  return ['LINK', 'MUTABLE', {
    url: url,
    isTargetBlank: true
  }];
}

function createEmbedEntityOptions(data) {
  return [_constants.ENTITY_TYPES.embed, 'IMMUTABLE', data];
}

function createQuestionAndAnswerEntityOptions(data) {
  return [_constants.ENTITY_TYPES.questionAndAnswer, 'IMMUTABLE', data];
} // Returns an editorState with entity added to it, without insert tools


function insertEntity(state, entityKey, changeType) {
  var target = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var currentEditorState = state.get('content');

  var editorStateWithEntity = _draftJs.AtomicBlockUtils.insertAtomicBlock(currentEditorState, entityKey, target);

  var currentContent = editorStateWithEntity.getCurrentContent();

  var newEditorState = _draftJs.EditorState.push(editorStateWithEntity, currentContent, changeType);

  return _draftJs.EditorState.forceSelection(newEditorState, newEditorState.getSelection());
}

function insertImageFromPicker(state, _ref) {
  var _state$content$getCur;

  var src = _ref.src,
      name = _ref.name;

  var contentStateWithEntity = (_state$content$getCur = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur, (0, _toConsumableArray2.default)(createImageEntityOptions(src, name)));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var editorStateWithImageEntity = insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.insertImage);
  var editorStateWithImageBlockData = (0, _convertImageEntitiesToBlockData.default)(editorStateWithImageEntity);
  return (0, _setSelectionAfterInsertedEntity.default)({
    editorState: editorStateWithImageBlockData,
    entityKey: entityKey
  });
}

function insertVideoFromPicker(state, videoData) {
  var _state$content$getCur2;

  var contentStateWithEntity = (_state$content$getCur2 = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur2, (0, _toConsumableArray2.default)(createVideoEntityOptions(videoData)));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var editorStateWithVideo = insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.insertVideo);
  return _draftJs.EditorState.forceSelection(editorStateWithVideo, editorStateWithVideo.getSelection());
}

function insertLinkClip(state, _ref2) {
  var _state$content$getCur3;

  var src = _ref2.src,
      title = _ref2.title;

  var contentStateWithEntity = (_state$content$getCur3 = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur3, (0, _toConsumableArray2.default)(createLinkEntityOptions(src)));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  return insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.insertLinkClip, title);
}

function insertEmbedFromModal(state, embedData) {
  var _state$content$getCur4;

  var contentStateWithEntity = (_state$content$getCur4 = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur4, (0, _toConsumableArray2.default)(createEmbedEntityOptions(embedData)));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var editorStateWithEmbed = insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.insertEmbed);
  return _draftJs.EditorState.forceSelection(editorStateWithEmbed, editorStateWithEmbed.getSelection());
}

function insertQuestionAndAnswer(state, data) {
  var _state$content$getCur5;

  var contentStateWithEntity = (_state$content$getCur5 = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur5, (0, _toConsumableArray2.default)(createQuestionAndAnswerEntityOptions(data)));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  var editorStateWithQuestionAndAnswer = _draftJs.EditorState.createWithContent(insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.questionAndAnswer).getCurrentContent());

  return (0, _setSelectionAfterInsertedEntity.default)({
    editorState: editorStateWithQuestionAndAnswer,
    entityKey: entityKey
  });
}

function parseClip(clip) {
  var referencePageFeaturedImageAltText = clip.referencePageFeaturedImageAltText,
      referencePageFeaturedImageUrl = clip.referencePageFeaturedImageUrl,
      referencePageTitle = clip.referencePageTitle,
      referencePageQuote = clip.referencePageQuote,
      referencePageUrl = clip.referencePageUrl,
      type = clip.type;
  var name = referencePageFeaturedImageAltText || referencePageTitle;
  var src = type === _constants.CLIP_TYPES.FULL_PAGE ? referencePageUrl : referencePageFeaturedImageUrl;
  return {
    attribution: referencePageUrl,
    name: name,
    quote: referencePageQuote,
    src: src,
    title: referencePageTitle,
    type: type
  };
}

function insertClip(state, clip) {
  var parsedClip = parseClip(clip);
  var editorStateWithClip; // for now (need to make ClipComponent handle links and raw clips)

  if (parsedClip.type === _constants.CLIP_TYPES.FULL_PAGE) {
    editorStateWithClip = insertLinkClip(state, parsedClip);
  } else {
    var _state$content$getCur6;

    var contentStateWithEntity = (_state$content$getCur6 = state.content.getCurrentContent()).createEntity.apply(_state$content$getCur6, (0, _toConsumableArray2.default)(createClipEntityOptions(parsedClip)));

    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    editorStateWithClip = insertEntity(state, entityKey, _constants2.EDITOR_CHANGE_TYPES.insertClip);
  }

  return _draftJs.EditorState.forceSelection(editorStateWithClip, editorStateWithClip.getSelection());
}

function cloneEditorState(editorState) {
  var withContent = _draftJs.EditorState.createWithContent(editorState.getCurrentContent());

  var withStacks = withContent.getImmutable().set('redoStack', editorState.getRedoStack()).set('undoStack', editorState.getUndoStack());
  return _draftJs.EditorState.forceSelection(new _draftJs.EditorState(withStacks), editorState.getSelection());
}

function Save() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _SaveState.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data;

  switch (action.type) {
    case _ActionTypes.default.SET_INITIAL_TITLE:
      return state.merge({
        status: _constants2.RequestStatus.UNINITIALIZED,
        title: data,
        titleChanged: false
      });

    case _ActionTypes.default.SET_INITIAL_CONTENT:
      return state.merge({
        status: _constants2.RequestStatus.UNINITIALIZED,
        content: data,
        contentChanged: false
      });

    case _ActionTypes.default.SET_INITIAL_SUMMARY:
      return state.merge({
        status: _constants2.RequestStatus.UNINITIALIZED,
        summary: data,
        summaryChanged: false
      });

    case _ActionTypes.default.SAVE_NEW_TITLE:
      // handle the case where the user just clicks into the title but doesn't make changes
      if (state.title === data) {
        return state;
      }

      return state.merge({
        title: data,
        titleChanged: true
      });

    case _ActionTypes.default.SAVE_NEW_SUMMARY:
      // handle the case where the user just clicks into the summary but doesn't make changes
      if (state.summary === data) {
        return state;
      }

      return state.merge({
        summary: data,
        summaryChanged: true
      });

    case _ActionTypes.default.SAVE_NEW_CONTENT:
      // handle the case where the user just clicks into the body but doesn't make changes
      if (state.content && data && (0, _immutable.is)(state.content.getCurrentContent(), data.getCurrentContent())) {
        // entity changes should force an actual change
        if (data.getLastChangeType() === 'apply-entity' || data.getLastChangeType() === 'update-entity' || data.getLastChangeType() === 'delete-entity') {
          return state.merge({
            content: data,
            contentChanged: true
          });
        }

        return state.merge({
          content: data
        });
      }

      if (data.getLastChangeType() === 'undo') {
        // Draft messes with focus on the page if you undo, so we have to create a new editor state
        // with copied contentState, selectionState, and undo/redo stacks which seems to appease it.
        // Seems like something within its internal state outside of these keys gets messed up on undo.
        return state.merge({
          content: cloneEditorState(data),
          contentChanged: true
        });
      }

      return state.merge({
        content: data,
        contentChanged: true
      });

    case _ActionTypes.default.SAVE_COMPOSITION_PENDING:
      return state.set('status', _constants2.RequestStatus.PENDING);

    case _ActionTypes.default.SAVE_COMPOSITION_SUCCEEDED:
      return state.merge({
        contentChanged: false,
        saveFailed: false,
        status: _constants2.RequestStatus.SUCCEEDED,
        summaryChanged: false,
        titleChanged: false
      });

    case _ActionTypes.default.SAVE_COMPOSITION_FAILED:
      return state.merge({
        saveFailed: true,
        saveFailedModal: true,
        status: _constants2.RequestStatus.FAILED
      });

    case _ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_SCOPE:
      return state.merge({
        requiredScope: data.responseJSON.errorTokens && data.responseJSON.errorTokens.requiredScope[0] || '',
        saveFailed: true,
        saveFailedModal: true,
        status: _constants2.RequestStatus.FAILED
      });

    case _ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_LOCK:
    case _ActionTypes.default.CONVERT_POST_FAILED_BECAUSE_OF_CONFLICT:
      return state.set('status', _constants2.RequestStatus.FAILED);

    case _ActionTypes.default.SAVE_COMPOSITION_FAILED_DISMISSED:
      return state.set('saveFailedModal', false);

    case _ActionTypes.default.LOCK_EDITING:
      return state.merge({
        locked: true,
        lockedBy: action.data.updatedUserName || state.lockedBy,
        lockVisible: true
      });

    case _ActionTypes.default.LOCK_EDITING_DISMISSED:
      return state.merge({
        locked: true,
        lockVisible: false
      });

    case _ActionTypes.default.HIGHLIGHT_BODY_TEXT:
      // Don't make any other edit to editorState if highlighted already, or undo won't reverse highlight
      if (state.get('highlighted')) {
        return state;
      }

      return state.merge({
        content: highlightConversationInComposer(action.data, state.get('content')),
        // Save a snapshot of the editorState before applying highlights to restore later
        contentBeforeHighlighted: state.get('content'),
        highlighted: true
      });

    case _ActionTypes.default.REMOVE_HIGHLIGHTED_BODY_TEXT:
      {
        // Load the editorState from before we highlighted anything
        var restoredContent = state.get('contentBeforeHighlighted') || state.get('content');
        return state.merge({
          content: restoredContent,
          contentBeforeHighlighted: null,
          highlighted: false
        });
      }

    case _ActionTypes.default.HIGHLIGHT_TITLE_TEXT:
      return state.set('titleHighlighted', true);

    case _ActionTypes.default.REMOVE_HIGHLIGHTED_TITLE_TEXT:
      return state.set('titleHighlighted', false);

    case _ActionTypes.default.HIGHLIGHT_SUMMARY_TEXT:
      return state.set('summaryHighlighted', true);

    case _ActionTypes.default.REMOVE_HIGHLIGHTED_SUMMARY_TEXT:
      return state.set('summaryHighlighted', false);

    case _ActionTypes.default.INSERT_IMAGE:
      return state.merge({
        content: insertImageFromPicker(state, action.data),
        insertableLoading: true
      });

    case _ActionTypes.default.INSERT_VIDEO:
      return state.merge({
        content: insertVideoFromPicker(state, action.data),
        contentChanged: true,
        insertableLoading: true
      });

    case _ActionTypes.default.INSERT_EMBED:
      return state.merge({
        content: insertEmbedFromModal(state, action.data),
        contentChanged: true,
        insertableLoading: true
      });

    case _ActionTypes.default.INSERT_QUESTION_AND_ANSWER:
      return state.merge({
        content: insertQuestionAndAnswer(state, action.data),
        contentChanged: true,
        insertableLoading: false
      });

    case _ActionTypes.default.INSERTABLE_LOADED:
      return state.merge({
        content: _draftJs.EditorState.forceSelection(state.content, state.content.getSelection()),
        contentChanged: true,
        insertableLoading: false
      });

    case _ActionTypes.default.INSERT_CLIP:
      return state.merge({
        clipLinkLoading: parseClip(action.data).type === _constants.CLIP_TYPES.FULL_PAGE,
        content: insertClip(state, action.data),
        insertableLoading: true
      });

    case _ActionTypes.default.RESTORE_SELECTION_AFTER_MANUAL_FOCUS:
      return state.set('content', _draftJs.EditorState.forceSelection(state.content, action.data));

    case _ActionTypes.default.CLIP_LINK_LOADED:
      return state.merge({
        clipLinkLoading: false,
        insertableLoading: false
      });

    default:
      return state;
  }
}

module.exports = exports.default;